import { render, staticRenderFns } from "./profile-educational.vue?vue&type=template&id=56b62606&"
import script from "./profile-educational.vue?vue&type=script&lang=js&"
export * from "./profile-educational.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/QI.Recrutement.FE/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import UiMaxWidth from '@/components/ui/max-width.vue'
installComponents(component, {UiMaxWidth})
